<template>
  <div>

    <div v-if="mode === 'DESIGN'">

      <el-input size="medium" disabled :placeholder="placeholder" />
    </div>
    <div v-else>
      <el-input
        size="medium"
        clearable
        v-model="value1"
        :placeholder="placeholder"
        @input="change($event)"
        :readonly="r"
      />
      <!--
        @change="change" -->
    </div>
  </div>
</template>

<script>
import componentMinxins from "../ComponentMinxins";

export default {
  mixins: [componentMinxins],
  name: "TextInput",
  components: {},
  props: {
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "请输入内容",
    },
    config1: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      value1: "",
      r: false,
    };
  },
  mounted() {
    this.value1 = this._value;
    setTimeout(() => {
      if (this.config1) {
        console.log(this.config1, "this.config1.perm");
        if (
          this.config1.flag == 2 ||
          this.config1.flag == 3 ||
          this.config1.flag == 4
        ) {
          console.log("仅可读仅可读");
          this.r = true;
        } else {
          var perm = this.config1.perm;
          if (perm == "R") {
            this.r = true;
          }
        }
      }
    }, 100);
  },
  // watch: {
  //   value1: {
  //     deep: true,
  //     handler(newVal, OldVal) {
  //       console.log(newVal, OldVal);
  //       this._value = this.value1;
  //       // this.$emit("input", newVal);
  //       // this.$store.commit("setFormValue", newVal);
  //     },
  //   },
  // },
  methods: {
    change(e, type) {
      console.log(e, "eeeee");
      // console.log(type, "type");
      // this.$set(this._value, "key", e);
      // var obj = { ...this._value.split(",") };
      // this.$set(obj, "0", e);
      // console.log(obj[0]);
      // this._value = obj[0];
      // console.log(this._value, "this._value");
      this.$emit("input", e);
      // }
    },
  },
};
</script>

<style scoped></style>
